import Alert from '@/components/ui/Alert.vue';
import AppBadge from '@/components/ui/AppBadge.vue';
import AppBanner from '@/components/ui/Banner.vue';
import AppCard from '@/components/ui/Card.vue';
import AppDrawer from '@/components/ui/Drawer.vue';
import EmptyState from '@/components/ui/EmptyState.vue';
import AppPagination from '@/components/ui/Pagination.vue';
import AppIcon from '@/components/ui/AppIcon.vue';
import AppTimeline from '@/components/ui/timeline/Timeline.vue';
import AppTimelineItem from '@/components/ui/timeline/TimelineItem.vue';
import BlockHeader from '@/components/headers/BlockHeader.vue';
import Collapse from '@/components/ui/Collapse.vue';
import CountryFlag from '@/components/ui/CountryFlag.vue';
import CheckboxButton from '@/components/form/CheckboxButton.vue';
import RadioButton from '@/components/form/RadioButton.vue';
import DataProperty from '@/components/ui/DataProperty.vue';
import DataTable from '@/components/table/DataTable.vue';
import DatePicker from '@/components/form/DatePicker.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import FormAutocomplete from '@/components/form/FormAutocomplete.vue';
import FormButton from '@/components/form/FormButton.vue';
import FormCountrySelect from '@/components/form/FormCountrySelect.vue';
import FormCurrencySelect from '@/components/form/FormCurrencySelect.vue';
import FormSelect from '@/components/form/FormSelect.vue';
import HeaderBackNavigation from '@/components/headers/HeaderBackNavigation.vue';
import ModalDialog from '@/components/ui/modal/ModalDialog.vue';
import Stat from '@/components/ui/Stat.vue';
import TagList from '@/components/form/TagList.vue';
import TextTruncate from '@/components/ui/TextTruncate.vue';
import TheTab from '@/components/ui/tab/Tab.vue';
import TheTabContent from '@/components/ui/tab/TabContent.vue';
import TheTabs from '@/components/ui/tab/Tabs.vue';
import Toast from '@/components/ui/Toast.vue';
import Tooltip from '@/components/ui/Tooltip.vue';
import PageBottomSummary from '@/components/layouts/PageBottomSummary.vue';
import PageHeader from '@/components/headers/PageHeader.vue';
import PageSummary from '@/components/layouts/PageSummary.vue';
import SectionHeader from '@/components/headers/SectionHeader.vue';
import StatusMessage from '@/components/ui/StatusMessage.vue';

export default {
  install: (app) => {
    app.component('AirwallexLogo', Alert);
    app.component('AppAlert', Alert);
    app.component('AppBadge', AppBadge);
    app.component('AppBanner', AppBanner);
    app.component('AppCard', AppCard);
    app.component('AppCollapse', Collapse);
    app.component('AppDrawer', AppDrawer);
    app.component('AppDropdown', Dropdown);
    app.component('AppEmptyState', EmptyState);
    app.component('AppPagination', AppPagination);
    app.component('AppToast', Toast);
    app.component('AppIcon', AppIcon);
    app.component('AppTab', TheTab);
    app.component('AppTabContent', TheTabContent);
    app.component('AppTabs', TheTabs);
    app.component('AppTimeline', AppTimeline);
    app.component('AppTimelineItem', AppTimelineItem);
    app.component('BlockHeader', BlockHeader);
    app.component('CountryFlag', CountryFlag);
    app.component('CheckboxButton', CheckboxButton);
    app.component('RadioButton', RadioButton);
    app.component('DataProperty', DataProperty);
    app.component('DataTable', DataTable);
    app.component('DatePicker', DatePicker);
    app.component('FormAutocomplete', FormAutocomplete);
    app.component('FormButton', FormButton);
    app.component('FormCountrySelect', FormCountrySelect);
    app.component('FormCurrencySelect', FormCurrencySelect);
    app.component('FormSelect', FormSelect);
    app.component('HeaderBackNavigation', HeaderBackNavigation);
    app.component('ModalDialog', ModalDialog);
    app.component('TagList', TagList);
    app.component('TextTruncate', TextTruncate);
    app.component('AppStat', Stat);
    app.component('AppTooltip', Tooltip);
    app.component('PageBottomSummary', PageBottomSummary);
    app.component('PageHeader', PageHeader);
    app.component('PageSummary', PageSummary);
    app.component('SectionHeader', SectionHeader);
    app.component('StatusMessage', StatusMessage);
  },
};
